import React, { useState, memo } from 'react';
const FAQ = () => {
  const faqs = [{
    question: 'How does SmartSoda enhance the showroom experience?',
    answer: 'SmartSoda provides premium beverages that create a welcoming atmosphere, increase customer dwell time, and provide a distinctive touchpoint that helps your showroom stand out from competitors.'
  }, {
    question: 'How does SmartSoda impact sales conversions?',
    answer: 'By creating a comfortable environment where customers can relax and spend more time in your showroom, SmartSoda helps sales teams build better relationships and have more meaningful conversations, leading to higher conversion rates.'
  }, {
    question: 'How does SmartSoda support our brand image?',
    answer: 'Our premium beverage systems align with luxury brand positioning, demonstrating attention to detail and customer care while also showcasing your commitment to sustainable practices.'
  }, {
    question: 'What types of beverages are available?',
    answer: "SmartSoda offers a wide selection, including premium still and sparkling waters, vitamin-infused waters, and 29+ flavor options—all with customizable carbonation levels to suit your customers' preferences."
  }, {
    question: 'How does the system work in a showroom environment?',
    answer: 'Our sleek, quiet dispensers can be placed in reception areas, consultation spaces, or throughout your showroom. The intuitive interface allows staff or customers to create the perfect beverage with just a few taps.'
  }, {
    question: 'Can we customize beverages for our brand?',
    answer: 'Yes! Many businesses create signature beverages that complement their brand identity—from custom menu displays to branded cups and special flavor combinations that become part of your unique customer experience.'
  }, {
    question: 'How much space does a SmartSoda dispenser require?',
    answer: 'Our machines are compact and designed to blend seamlessly into premium environments, requiring minimal counter space while making a maximum impression.'
  }, {
    question: "What's required for installation?",
    answer: 'SmartSoda dispensers connect to your existing water source and power supply, making installation quick and hassle-free. Professional installation is handled by our certified technicians.'
  }, {
    question: 'How does SmartSoda support sustainability initiatives?',
    answer: 'By eliminating single-use plastic bottles and cans, SmartSoda helps reduce waste by up to 90% while also reducing carbon emissions associated with beverage transportation and refrigeration.'
  }, {
    question: 'How can I get started?',
    answer: "Contact us today to schedule a consultation and bring SmartSoda to your showroom! We'll create a custom solution that perfectly complements your customer experience."
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20 bg-gray-50" id="faq" data-id="element-179">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-182">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-183">
            Everything you need to know about SmartSoda for your showroom
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-184">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-100 last:border-b-0" data-id="element-185">
              <button className="w-full px-6 py-5 text-left focus:outline-none" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-186">
                <div className="flex justify-between items-center" data-id="element-187">
                  <h3 className="text-lg font-medium text-navy-950" data-id="element-188">
                    {faq.question}
                  </h3>
                  <span className="ml-6 flex-shrink-0" data-id="element-189">
                    <svg className={`h-6 w-6 transform ${openIndex === index ? 'rotate-180' : 'rotate-0'} transition-transform duration-200 ease-in-out text-gray-500`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-190">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-191" />
                    </svg>
                  </span>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-192">
                <div className="px-6 text-gray-600" data-id="element-193">{faq.answer}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FAQ;